<template>
  <div>
    <form @submit.prevent="onSubmit">
      <div class="modal-form-block mb-6">
        <label for="excelFile">
          {{ trans.get('dealers.importer-file-input') }}
        </label>
        <div class="relative flex items-center">
          <input name="excelFile"
                 type="file"
                 @change="onChange"
          >
        </div>
      </div>
      <div class="modal-form-block mb-6">
        <button class="w-1/3 mx-auto btn is-aitems-700">
          {{ trans.get('dealers.importer-btn') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {

  data() {
    return {
      excelFile: '',
      isLoading: false,
    }
  },

  methods: {
    onSubmit() {
      this.isLoading = true;

      let payload = new FormData();

      payload.append('excelFile', this.excelFile);

      axios.post('/warranty/dealers/import', payload)
        .then(() => {
          this.$toastr.s('Dealers successfully Imported');
          this.isLoading = false;
        })
    },

    onChange(e) {
      if (!e.target.files.length) return;
      this.excelFile = e.target.files[0];
    },
  }
}
</script>

<style scoped>

</style>